<template>
  <div v-if="hasMultipleCcs" class="cc-capsule with-tooltip">
    <el-tooltip>
      <div>
        <span class="label">cc</span>
        <span class="message">{{ capsuleText }}</span>
      </div>
      <template #content>
        <div>
          <div v-for="(cc, index) in ccs" :key="index">
            {{ cc }}<br>
          </div>
        </div>
      </template>
    </el-tooltip>
  </div>
  <div v-else class="cc-capsule">
    <span class="label">cc</span>
    <span class="message">{{ capsuleText }}</span>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'CcCapsule',

  props: {
    ccs: {
      type: Array as () => string[],
      required: true,
    },
  },

  computed: {
    hasMultipleCcs(): boolean {
      return this.ccs.length > 1
    },
    capsuleText(): string {
      if (this.ccs.length === 2) {
        return `${this.ccs[0]} & one other email…`
      } else if (this.hasMultipleCcs) {
        return `${this.ccs[0]} & ${this.ccs.length - 1} emails…`
      } else {
        return this.ccs[0]
      }
    },
  },
})
</script>

<style lang="scss">
.cc-capsule {
  display: flex;
  align-items: center;
  border-radius: 14px;
  padding: 2px 12px;
  overflow: hidden;
  border: $border--solid-extra-light;
  background-color: var(--color-background-secondary);

  &.with-tooltip {
    cursor: default;

    &:hover {
      background-color: $color--gray-30;
    }
  }

  div {
    display: flex;
    align-items: center;
  }

  .label {
    @include lettering--h5;
    position: relative;
    top: 1px;
    padding-right: 6px;
    color: var(--color-text-primary);
  }

  .message {
    @include lettering--p-sm;
    color: var(--color-text-primary);
    @include single-line-ellipsis;
  }
}
</style>
